import { Injectable, OnDestroy } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { SubSink } from 'subsink';

@Injectable({
  providedIn: 'root'
})
export class PwaService implements OnDestroy {

  private readonly subSink: SubSink;

  constructor(private swUpdate: SwUpdate) {
    this.subSink = new SubSink();
    this.subSink.sink = swUpdate.available.subscribe(event => {
      //TODO: may ask user before reload page
      window.location.reload();
    });
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
